import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

import { renalDetectFeatureKey } from '../pages/renal-detect/store/renal-detect-feature-key';
import { smartRecoFeatureKey } from '@app/pages/smart-reco/store/smart-reco-feature-key';
import { consultationFeatureKey } from './consultation';
import { dailyAllowanceFeatureKey } from '@app/pages/daily-allowance/store/daily-allowance-feature-key';
import { weightManagementFeatureKey } from '@app/pages/weight-management/store/weight-management-feature-key';
import { newPetFeatureKey } from '@app/pages/new-pet/store/new-pet-feature-key';
import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';

/**
 * Save account data into local storage & rehydrate on app launch
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      { core: ['localization', 'tool', 'prevTool', 'tool_flow_id'] },
      { vet: ['currentClinicId', 'invitation'] },
      consultationFeatureKey,
      smartRecoFeatureKey,
      renalDetectFeatureKey,
      dailyAllowanceFeatureKey,
      weightManagementFeatureKey,
      newPetFeatureKey,
      {
        products: [
          'allProductList',
          'filteredProductList',
          'filteredProductLength',
          'filtersValues',
          'currentPillar',
          'selectedCategories',
          'selectedProducts',
          'specificSpecieCode',
          'specificLifestageType',
        ],
      },
      StateNamesEnum.SHARE_RECOMMENDATION_STATE_NAME,
      StateNamesEnum.PET_STATE_NAME,
      StateNamesEnum.PATIENT_PROFILE_STATE_NAME,
      StateNamesEnum.ALLOWANCE,
    ],
    rehydrate: true,
  })(reducer);
}
